import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { DataGrid, GridActionsCellItem, GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { FirebaseService, Person, useFirebaseService } from '../../../data/FirebaseService';
import { useParams } from 'react-router-dom';
import { Delete, Group } from '@mui/icons-material';
import ConfirmationDialog from '../../../ui/ConfirmationDialog';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FirebaseConfig } from '../../../data/firebaseConfig';
import { toast } from 'react-toastify';
import { AddGroupMembers } from './AddGroupMembers';

const GroupPage: React.FC = () => {
    const [group, setGroup] = useState<any>([]);
    const [members, setMembers] = useState<any[]>([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState<Person | null>(null);
    const firebaseService = useFirebaseService();
    const { id } = useParams();

    const functions = getFunctions(FirebaseConfig.app);
    const removeGroupMember = httpsCallable(functions, "removeGroupMember");

    const fetchMembers = async (groupName: string) => {
        if (firebaseService) {
            const collection = await firebaseService.getCollection(`people`);
            const q = query(collection,
                where('groups', "array-contains", groupName),
            );
            const querySnapshot = await getDocs(q);
            const membersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            setMembers(membersList);
        }
    };

    useEffect(() => {
        if (firebaseService && id) {
            const fetchGroup = async () => {
                const group = await firebaseService.getDocument('groups', id) as any;

                setGroup(group);

                fetchMembers(group.name);
            };

            fetchGroup();
        }
    }, [firebaseService, id]);



    const columns: GridColDef[] = [
        {
            field: 'name', headerName: 'Member Name', width: 200,
            valueGetter: (params, row) => `${row.firstName} ${row.lastName}`
        },
        // {
        //     field: 'type',
        //     headerName: 'Type',
        //     width: 150,
        //     renderCell: (params) => (
        //         params.value === 'person' ? <Person /> : <Group />
        //     ),
        // }
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            getActions: (params) => {
                return [
                    (<GridActionsCellItem
                        label="Delete"
                        onClick={() => handleDelete(params.row)}
                        showInMenu={false}
                        icon={<Delete />}
                    />)
                ];
            }
        }
    ];

    const handleDelete = (row: Person) => {
        setCurrentRow(row);
        setOpenDeleteDialog(true);
    }

    const handleConfirmDelete = async () => {
        if (currentRow && group) {
            try {
                await removeGroupMember({ groupName: group.name, personId: currentRow.id });
                setMembers(members.filter(member => member.id !== currentRow.id));
            }
            catch (e) {
                console.error(e);
                toast.error('Failed to remove group member. Please try again.', { position: 'bottom-right' });
            }
        }
        // Add your disable logic here
        setOpenDeleteDialog(false); // Close the dialog after confirming
    };


    return (
        <div>
            <Typography variant="h5" component="h2" className='page-title'>Group - {group?.name}</Typography>
            <AddGroupMembers groupName={group?.name} onAddPeople={() => fetchMembers(group?.name)} />
            <div style={{ height: 400, width: '100%' }}>
                <DataGrid rows={members} columns={columns} />
            </div>
            <ConfirmationDialog open={openDeleteDialog}
                title='Confirm Delete'
                content='Are you sure you want to remove this group member?'
                onConfirm={handleConfirmDelete}
                onCancel={() => setOpenDeleteDialog(false)} />
        </div>
    );
};

export default GroupPage;
